import {
    Button,
    Icon,
    Link,
    TextField,
    Tooltip,
    Modal,
    Thumbnail,
    Pagination,
    Badge,
    Text,
    BlockStack,
    InlineStack,
    Card,
    Popover,
    Box,
    Divider,
    InlineGrid,
    Bleed
} from '@shopify/polaris';
import {
    ExternalMinor,
    SearchMinor,
} from "@shopify/polaris-icons";
import { Table } from 'antd';
import React, { useCallback, useState, useEffect, ReactElement, useContext } from 'react';
import { DI, DIProps } from '../../../../Core';
import debounce from 'lodash/debounce';
import Noimage from "../../../../../public/files/noImage.png";
import AmazonBtnIcon from "../../../../Asests/Images/amazon_icon.png";
import ShopifyBtnIcon from "../../../../Asests/Images/shopify_icon.png";
import { getAmazonStatus } from '../../Settings/Template/Components/FilterProducts/FilterProductsHelper'
import { LinkSkeleton } from '../skeleton/LinkingSkeleton';
import SyncModal from './SyncModal';
import { ProductLinkingContext } from './utils/context/context';
import { amazon_regions } from '../../Onboarding/components/onboardinghelper';
import { isAdminLoggedIn } from '../../Panel/index';
import { ViewMoreInfo } from './utils/utils';

import { useTranslation } from "react-i18next";
import { modifyImageUrl } from '../../Listing Grid/Utilities/Helper';
import { LazyThumbnail } from '../../Editproduct/components/Image/Image';
interface Props extends DIProps {
    viewSku?: string;
}
var timer: ReturnType<typeof setTimeout>;

/**
 * This component is responsible for the dashboard structure
 * @param props
 * @returns
 */
function Linked(props: Props): ReactElement {
    const { t } = useTranslation();
    const myContext: any = useContext(ProductLinkingContext);
    const necessaryDetails = { ...myContext.necessaryDetails };

    const [inputValue, setInputValue] = useState(props.viewSku ?? "");
    const [tableLoading, setTableLoading] = useState(true);
    const [products, setProducts] = useState([]);
    const [data, setData] = useState([]);
    const [modal, setModal] = useState(false);
    const [buttonLoading, setbuttonLoading] = useState(false);
    const [selectedElement, setSelectedElement] = useState<any>({});
    const [summaryOfTable, setSummaryOfTable] = useState<JSX.Element>(<></>);
    const [hasUnlinked, setHasUnlinked] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPage, setTotalPage] = useState(0);
    const [count, setCount] = useState(10);
    const [hasPageChanged, setHasPageChanged] = useState(false);
    const [viewMoreInfo, setViewMoreInfo] = useState<string>('');

    const getLinkedListing = () => {
        setTableLoading(true);
        let data: any = {};
        data = {
            ...necessaryDetails,
            'data': {
                'matched': "true",
                'activePage': currentPage,
                'count': count,
            },
            'fulfillment-channel': myContext.fulfillmentType == 'FBM' ? 'DEFAULT' : 'FBA',
        }
        if (inputValue != "") {
            let filters: any = {};
            filters = {
                'or_filter': { 'item-name': { "3": inputValue }, 'seller-sku': { "3": inputValue }, 'product-id': { "3": inputValue }, 'matchedProduct.sku': { "3": inputValue } }
            }
            data = Object.assign({ ...data }, filters);
        }
        props.di.POST(`amazon/product/getAmazonListing`, data).then(val => {
            if (val.success) {
                myContext.getListingCount('linked');
                myContext.renderListingCount({ 'linked': val?.total_products });
                handleTotalpage(val?.total_products);
                setProducts(val.response);
            } else {
                props.error(t(val.error) ?? t("Request unsuccessful"));
            }
            setTableLoading(false);
        })
    };

    const handleTotalpage = (totalProducts: number) => {
        let pages = 0;
        if (totalProducts % count === 0) {
            pages = totalProducts / count;
        } else {
            pages = Math.trunc(totalProducts / count) + 1;
        }
        setTotalPage(pages);
    };

    var debounceListing = debounce(() => getLinkedListing(), 1000);

    useEffect(() => {
        getLinkedListing();
    }, []);

    useEffect(() => {
        debounceListing();
    }, [inputValue]);

    useEffect(() => {
        return () => {
            debounceListing.cancel();
        };
    }, [debounceListing]);

    const linkedcolumns: any = [
        {
            title: <Text variant="headingXs" as="h6" tone="subdued" fontWeight="medium">Amazon</Text>,
            dataIndex: "amazon",
            key: "amazon",
            width: 400,
        },
        {
            title: "",
            key: "status",
            dataIndex: "status",
            width: 100,
            align: "center",
        },
        {
            title: <Text variant="headingXs" as="h6" tone="subdued" fontWeight="medium">Shopify</Text>,
            dataIndex: "shopify",
            key: "shopify",
            width: 400,
        },
        {
            title: <Text variant="headingXs" as="h6" tone="subdued" fontWeight="medium">Action</Text>,
            key: "action",
            dataIndex: "action",
            width: 200,
            align: "center",
        }
    ];

    useEffect(() => {
        renderLinkedListing();
    }, [products, viewMoreInfo]);

    const renderStatusOfProduct = (status: string) => {
        if (status === "Active") {
            return (<Badge tone="success">{status}</Badge>);
        }
        else if (status === "Incomplete") {
            return (<Badge tone="warning">{status}</Badge>)
        }
        return (<Badge tone="critical">{status}</Badge>);
    }

    const handleUnlinkModal = () => {
        setModal(!modal);
    }

    const getStatus = (status: any) => {
        let statusInfo: any = getAmazonStatus(status);
        return (<Badge tone={statusInfo}>{status == "" ? t("Not Listed") : t(status)}</Badge>)
    }

    const button: any = <InlineStack gap="100" blockAlign='center'>
        <img src={AmazonBtnIcon} height="14px" width="14px" />
        <Icon
            source={ExternalMinor}
            tone="info"
        />
    </InlineStack>;

    const button2: any = <InlineStack gap="100" blockAlign='center'>
        <img src={ShopifyBtnIcon} />
        <Icon
            source={ExternalMinor}
            tone="info"
        />
    </InlineStack>;

    const renderLinkedListing = () => {
        let linkedData: any = [];
        if (products.length > 0) {
            products.forEach((val: any, i) => {
                let current_shop_currency: any = amazon_regions.filter((value: any) => value?.currency == props?.redux?.current?.source?.currency)?.[0];
                linkedData.push(
                    {
                        key: i.toString(),
                        amazon: <InlineStack gap='300' wrap={false}>
                            {/* <img width={"60px"} height={"60px"} src={val?.['image-url'] && val?.['image-url'] != "" ? val?.['image-url'] : Noimage} /> */}
                            <LazyThumbnail
                                src={val?.['image-url'] && val?.['image-url'] != "" ? modifyImageUrl(val?.['image-url']) : Noimage}
                                alt='productImages'
                                key={val?.['image-url'] && val?.['image-url'] != "" ? modifyImageUrl(val?.['image-url']) : Noimage + 'Thumbnail' + Math.random()}
                                size='medium'
                                className='custom-linking-lazy__thumbnail'
                            />

                            <BlockStack gap='100'>
                                <div style={{ minWidth: "200px" }}>
                                    {val?.['item-name'].length > 100 ?
                                        <Tooltip content={val['item-name']}>
                                            <Text variant="headingSm" as="h3">{val['item-name'].substring(0, 100)}...</Text>
                                        </Tooltip>
                                        :
                                        <Text variant="headingSm" as="h3">{val['item-name']}</Text>
                                    }
                                </div>
                                <InlineStack gap='100' >
                                    <Text as="p" fontWeight="regular">{t("Seller SKU:")}</Text>
                                    <Text as='p' tone="subdued">{val?.['seller-sku']}</Text>
                                </InlineStack>
                                <InlineStack gap='100' >
                                    <Text as="p" fontWeight="regular">{t("Barcode:")}</Text>
                                    <Text as='p' tone="subdued">{val?.['product-id']}</Text>
                                </InlineStack>
                                <InlineStack gap='300' wrap={false} blockAlign='center'>
                                    <div>
                                        <Button url={myContext.viewOnAmazon(val?.['asin1'])} target='_blank'>{button}</Button>
                                    </div>
                                    <ViewMoreInfo val={val} renderStatusOfProduct={renderStatusOfProduct} current_shop_currency={current_shop_currency} />
                                </InlineStack>
                                <div>
                                    {val?.['type'] === "variation" ? <Badge tone="info">{t("Parent")}</Badge> : null}
                                </div>
                            </BlockStack>
                        </InlineStack >,
                        shopify: <InlineStack gap='300' wrap={false}>
                            {/* <img width={"60px"} height={"60px"} src={val?.['matchedProduct']?.['main_image'] && val?.['matchedProduct']?.['main_image'] != "" ? val?.['matchedProduct']?.['main_image'] : Noimage} /> */}
                            <LazyThumbnail
                                src={val?.['matchedProduct']?.['main_image'] && val?.['matchedProduct']?.['main_image'] != "" ? modifyImageUrl(val?.['matchedProduct']?.['main_image']) : Noimage}
                                alt='productImages'
                                key={val?.['matchedProduct']?.['main_image'] && val?.['matchedProduct']?.['main_image'] != "" ? modifyImageUrl(val?.['matchedProduct']?.['main_image']) : Noimage + 'Thumbnail' + Math.random()}
                                size='medium'
                                className='custom-linking-lazy__thumbnail'
                            />
                            <BlockStack gap='100'>
                                <div style={{ minWidth: "200px" }}>
                                    {val?.['matchedProduct']?.['title']?.length > 100 ?
                                        <Tooltip content={val?.['matchedProduct']?.['title']}>
                                            <Text variant="headingSm" as="h3">{val?.['matchedProduct']?.['title'].substring(0, 100)}...</Text>
                                        </Tooltip>
                                        :
                                        <Text variant="headingSm" as="h3">{val?.['matchedProduct']?.['title']}</Text>
                                    }
                                </div>
                                <InlineStack gap='100' >
                                    <Text as="p" fontWeight="regular">{t("Seller SKU:")}</Text>
                                    <Text as='p' tone="subdued">{val?.['matchedProduct']?.['sku']}</Text>
                                </InlineStack>
                                <InlineStack gap='100'>
                                    <Text as="p" fontWeight="regular">{t("Barcode:")}</Text>
                                    <Text as='p' tone="subdued">{val?.['matchedProduct']?.['barcode']}</Text>
                                </InlineStack>
                                <div>
                                    <Button url={myContext.viewOnShopify(val?.['source_container_id'])} target='_blank'>{button2}</Button>
                                </div>
                            </BlockStack>
                        </InlineStack >,
                        status: <Text as='p'>{getStatus(val['status'])}</Text>,
                        action: <div style={{ color: '#bf0711' }}>
                            <Button tone="critical" onClick={() => { setSelectedElement(val); handleUnlinkModal(); }}>{t("Unlink")}</Button>
                        </div>
                    },
                )
            })
        }
        setData(linkedData);
    }

    const handleUnlinkAction = (
        product_ids: string,
        operation: boolean
    ) => {
        let data: any = {};

        data = {
            ...necessaryDetails,
            data: {
                _id: selectedElement._id.$oid,
                automate_sync: operation,
                source_product_id: selectedElement?.['source_product_id'],
            },
        }
        setbuttonLoading(true);
        props.di.POST(`amazon/product/manualUnmap`, data).then(val => {
            if (val.success) {
                props.success(t(val.message) ?? t("Request unsuccessful"));
                setHasUnlinked(true);
                getLinkedListing();
                clearTimeout(timer);
                renderSummaryOfTable('unlink', selectedElement);
                setSelectedElement({});
            } else {
                props.error(t(val.message) ?? t("Request unsuccessful"));
            }
            setbuttonLoading(false);
            handleUnlinkModal();
        })
    }

    const updateText = useCallback((value: any) => { setCurrentPage(1); setInputValue(value) }, []);
    const handleClearButtonClick = useCallback(() => updateText(''), []);

    const renderSummaryOfTable = (type: string, data: any) => {
        let summary: JSX.Element = <Table.Summary fixed="top">
            <Table.Summary.Row>
                <Table.Summary.Cell index={0} colSpan={5}>
                    <InlineStack gap='200' blockAlign="center">
                        {/* <Thumbnail source={data["image-url"]} size={"medium"} alt="" /> */}
                        <LazyThumbnail
                            src={data["image-url"] ? modifyImageUrl(data["image-url"]) : Noimage}
                            // src={img}
                            alt='productImages'
                            key={data["image-url"] + 'Thumbnail' + Math.random()}
                            size='medium'
                            className='custom-linking-lazy__thumbnail'
                        />
                        <Text as='p' fontWeight="semibold">
                            {t("Product was unlinked.")}&nbsp;
                            <Button variant='plain' onClick={() => { myContext.viewProductValue(1, data['seller-sku']); }}>
                                {t("View Product.")}
                            </Button>
                        </Text>
                    </InlineStack>
                </Table.Summary.Cell>
            </Table.Summary.Row>
        </Table.Summary>
        setSummaryOfTable(summary);
        timer = setTimeout(() => {
            setHasUnlinked(false);
            setSummaryOfTable(<></>);
        }, 30000);
    }
    useEffect(() => {
        getLinkedListing();
        // }, [currentPage, props.fulfillmentType])
    }, [currentPage, myContext.fulfillmentType])

    const handlePreviousPagination = () => {
        if (currentPage > 1) setCurrentPage(currentPage - 1);
        setHasPageChanged(!hasPageChanged);
    }

    const handleNextPagination = () => {
        if (currentPage !== totalPage) setCurrentPage(currentPage + 1);
        setHasPageChanged(!hasPageChanged);
    }

    return (
        <div>
            <BlockStack gap='200'>
                <div style={{ flex: '1 1 auto' }}>
                    <TextField
                        onChange={updateText}
                        value={inputValue}
                        prefix={<Icon source={SearchMinor} tone="base" />}
                        placeholder={t("Search by Amazon Title, Barcode, SKU, or Shopify SKU")}
                        onClearButtonClick={handleClearButtonClick}
                        clearButton={true}
                        label=""
                        autoComplete=""
                    />
                </div>
                <div className={hasUnlinked ? "custom-productlinking declined" : "custom-productlinking"}>
                    <Card padding="0">
                        {!tableLoading ? (
                            <Table sticky summary={() => summaryOfTable} columns={linkedcolumns} dataSource={data} scroll={{ x: 700 }} pagination={false} loading={tableLoading} size='middle' />) : (<LinkSkeleton />)
                        }
                    </Card>
                </div>

                {totalPage > 0 &&
                    <InlineStack align="center" gap='400'>
                        <Pagination
                            label={`${currentPage} / ${totalPage}`}
                            hasPrevious={currentPage <= 1 ? false : true}
                            onPrevious={() => {
                                handlePreviousPagination()
                            }}
                            hasNext={currentPage === totalPage ? false : true}
                            onNext={() => {
                                handleNextPagination()
                            }}
                        />
                    </InlineStack>
                }
            </BlockStack>
            {
                modal ? <SyncModal
                    {...props}
                    syncmodalLoading={buttonLoading}
                    actiontype={{
                        title: 'Unlink Product',
                        actionName: 'Save',
                        checked: (selectedElement?.automate_sync == undefined)
                        // checked: selectedElement?.automate_sync ? false : true,
                    }}
                    syncAction={handleUnlinkAction}
                    syncModal={modal}
                    setsyncModal={handleUnlinkModal}
                /> : <></>
            }
        </div >
    )
}
export default DI(Linked);